<template>
    <div>
        <b-navbar type="light" class="custom-small-only mobile-navbar-frame">
            <!--Menu-->
            <b-navbar-nav v-show="menuComponents.hamburger.visible">
                <b-nav-item @click="togglePanel({panelName: menuPanelName})" :title="$t(menuComponents.hamburger.tooltip)">
                    <div class="icon-container">
                        <div class="img-size-20" :class="menuComponents.hamburger.icon"></div>
                    </div>
                </b-nav-item>
            </b-navbar-nav>
            <!--Logo + Name-->
            <b-navbar-nav class="smaller-size" v-show="menuComponents.logo.visible">
                <b-nav-item>
                    <img :src="menuComponents.logo.imageUrl" :alt="menuComponents.logo.logo" class="image-container">
                </b-nav-item>
                <b-nav-text class="d-flex align-items-center ml-2 text-nowrap" :style="nameStyle">
                    {{name}}
                </b-nav-text>
            </b-navbar-nav>
            <!--Search + filter-->
            <b-navbar-nav class="navbar-search bg-white"
                          :class="[
                              showSearch ? 'center-horizontal' : 'align-right',
                              searchFieldIsOpenOnSmallDevice ? 'search-open' : ''
                          ]"
                          v-show="menuComponents.mapControls.visible">
                <div v-if="showSearchComponent" class="map-search-container">
                    <map-search :search-text="menuComponents.mapControls.components.search.textToSearch"
                                :search-suggestions="menuComponents.mapControls.components.search.suggestions"
                                :search-show-suggestions="menuComponents.mapControls.components.search.showResults"
                                :show-search-icon="!isSmallDevice"
                                mode="web-large"
                                @open="openSearchResultFromMenuBar($event)"
                                @reset="searchFromMenuBar({searchText: undefined})"
                                @updateDebounced="searchFromMenuBar({searchText: $event})"
                                @update="$_updateSearchText({searchText: $event})"></map-search>
                </div>
                <!--Toggable search for small devices-->
                <b-nav-item v-if="showSearchButton"
                            @click="toggleSearchField"
                            :title="$t('searchButtonText')"
                            class="d-none toggable-search">
                    <div class="icon-container">
                        <div class="search-icon img-size-20"></div>
                    </div>
                </b-nav-item>
                <!--Filter-->
                <b-nav-item
                    v-show="menuComponents.mapControls.components.filter.visible"
                    @click="togglePanel({panelName: filtersPanelName})"
                    :title="$t(menuComponents.mapControls.components.filter.label)"
                >
                    <div class="icon-container">
                        <div class="filter-icon img-size-20"></div>
                    </div>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import { INTERFACE_PANEL_TRIGGERS, devices } from '../../../../constants';
    import SearchInput from './SearchInput.vue';

    export default {
        name: 'mobile-nav-bar',
        components: { 'map-search': SearchInput },
        data() {
            return {
                menuPanelName: INTERFACE_PANEL_TRIGGERS.MENU,
                searchResultsPanelName: INTERFACE_PANEL_TRIGGERS.SEARCH_RESULTS,
                filtersPanelName: INTERFACE_PANEL_TRIGGERS.FILTERS,
                showSearchField: false, // Controls the visibility of the search field
                isSmallDevice: false
            };
        },
        mounted() {
            this.$_subscribeToWindowsMessages();
            this.$_onResizeWindow();
        },
        destroyed() {
            this.$_unsubscribeToWindowsMessages();
        },

        computed: {
            ...mapState(['uiElements']),
            ...mapGetters(['getWebTheme']),
            menuComponents: function() {
                return this.uiElements.menuBar.components;
            },
            showSearch() {
                return this.getWebTheme?.data?.showSearch;
            },
            showSearchComponent() {
                if (this.showSearch) {
                    return this.isSmallDevice ? this.showSearchField : true;
                }
                return false;
            },
            showSearchButton() {
                return this.isSmallDevice && this.showSearch;
            },
            searchFieldIsOpenOnSmallDevice() {
                return this.isSmallDevice && this.showSearchField;
            },
            showFullScreen() {
                return this.getWebTheme?.data?.showFullScreen;
            },
            nameStyle() {
                return `color: ${this.getWebTheme?.data?.nameFillColor};font-size: 20px;`;
            },
            name() {
                return this.getWebTheme?.data?.name;
            }
        },

        methods: {
            ...mapActions(['searchFromMenuBar', 'openSearchResultFromMenuBar', 'togglePanel']),
            $_updateSearchText(searchText) {
                this.$store.commit('UPDATE_SEARCH_SEARCHTEXT', searchText);
            },
            toggleSearchField() {
                this.showSearchField = !this.showSearchField;
            },
            $_subscribeToWindowsMessages() {
                window.addEventListener('resize', this.$_onResizeWindow);
            },
            $_unsubscribeToWindowsMessages() {
                window.removeEventListener('resize', this.$_onResizeWindow);
            },
            $_onResizeWindow() {
                this.isSmallDevice = window.innerWidth <= devices.sizes.SMALL;
            }
        }
    };
</script>

<style scoped lang="scss">
    .mobile-navbar-frame {
        @include z-index(menu-bar);
        background: #FFFFFF;
        box-shadow: 1px 2px 4px rgba(204, 204, 204, 0.5), 0px 2px 0px #A6AEBE;
        height: 60px;
        padding-left: 0.4rem;
        padding-right: 0.4rem;
    }

    .image-container {
        background-size: contain;
        background-repeat: no-repeat;
        height: 36px;
        cursor: context-menu;
    }

    .map-search-container {
        padding: 0.5rem 0px 0.5rem 0.3rem;
    }

    .context-icon {
        position: relative;
        left: 33%;
        top: 33%;
    }

    .navbar-nav .nav-link {
        padding-right: 0px;
        padding-left: 0.3rem;
    }

    .img-size-8 {
        width: 8px;
        height: 8px;
        background-size: 8px;
        -webkit-mask-size: 8px;
        mask-size: 8px;
    }

    .img-size-20 {
        width: 20px;
        height: 20px;
        background-size: 20px;
        -webkit-mask-size: 20px;
        mask-size: 20px;
    }

    .img-size-20x4 {
        width: 20px;
        height: 4px;
        background-size: 20px;
        -webkit-mask-size: 20px;
        mask-size: 20px;
    }

    .img-size-24 {
        width: 24px;
        height: 24px;
        background-size: 24px;
        -webkit-mask-size: 24px;
        mask-size: 24px;
    }

    .align-right {
        right: 0;
        position: absolute;
    }

    /* Mobiles/Tablets */
    @media (max-width: 767px) {
        .custom-small-only {
            .navbar-search {
                left: auto;
                transform: none;
                right: 0;

                .map-search-container {
                    width: 100%;
                }
            }

            .search-open {
                width: calc(100% - 50px); // keeps 50px space open on the left for the menu icon
            }

            .smaller-size {
                transform: scale(0.65);
                transform-origin: left;
            }

            .toggable-search {
                display: block !important;

                .search-icon {
                    mask-image: url(~@/assets/imported-icons/ic_fluent_search_20_regular.svg);
                }
            }
        }
    }

    /* Laptops */
    @media (min-width: 768px) and (max-width: 1024px) {
        .custom-small-only {
            .smaller-size {
                transform: scale(0.75);
                transform-origin: left;
            }
        }
    }
</style>
